/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Legajox_Ingest_Approval_DenyInputs */

const es_components_legajox_ingest_approval_deny = /** @type {(inputs: Components_Legajox_Ingest_Approval_DenyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denegar`)
};

const en_components_legajox_ingest_approval_deny = /** @type {(inputs: Components_Legajox_Ingest_Approval_DenyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deny`)
};

/**
* | output |
* | --- |
* | "Deny" |
*
* @param {Components_Legajox_Ingest_Approval_DenyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_legajox_ingest_approval_deny = /** @type {((inputs?: Components_Legajox_Ingest_Approval_DenyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Legajox_Ingest_Approval_DenyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_legajox_ingest_approval_deny(inputs)
	return en_components_legajox_ingest_approval_deny(inputs)
});
export { components_legajox_ingest_approval_deny as "components.legajox_ingest_approval.deny" }